import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useAuth } from "@/auth";

function AuthLayout() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <div className="h-screen bg-background" />;
  }

  return <Outlet />;
}

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
});
